import { FC } from 'react';
import styled, { keyframes } from 'styled-components';
import SuccessIcon from './SuccessIcon';
const pulse = keyframes`
  0% {
    opacity: 0;
    transform: rotate(90deg);
  }
  100%  {
    opacity: 1;
    transform: scale(1.5) rotate(0deg)
  }
`;
const Animated = styled.div`
  animation: ${() => pulse} 2.5s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  position: relative;
  width: fit-content;
`;
interface SuccessIconProps {
  width?: string;
}
const SuccessIconAnimated: FC<SuccessIconProps> = ({ width }) => {
  return (
    <Animated>
      <SuccessIcon width={width} />
    </Animated>
  );
};

export default SuccessIconAnimated;
